import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type TViewMode = 'hybrid' | 'map' | 'list';

export type ListingLayoutState = {
  filtersHeight: number;
  viewMode: TViewMode;
};

const listingLayoutInitialState: ListingLayoutState = {
  filtersHeight: 0,
  viewMode: 'hybrid',
};

export const { reducer: listingLayoutReducer, actions: listingLayoutActions } = createSlice({
  initialState: listingLayoutInitialState,
  name: 'listingLayout',
  reducers: {
    setFiltersHeight(state, action: PayloadAction<number>) {
      state.filtersHeight = action.payload;
    },
    setViewMode(state, action: PayloadAction<TViewMode>) {
      state.viewMode = action.payload;
    },
    toggleIsNarrow(state) {
      state.viewMode = state.viewMode === 'list' ? 'hybrid' : 'list';
    },
  },
});
